import React from "react";
import {Box, CircularProgress} from "@mui/material";

export const Spinner = () => (
  <Box>
      <CircularProgress size={200}/>
  </Box>
);
